module.exports = __webpack_public_path__ + "static/media/logo-liram.aacff105.png";